import React, { Fragment } from "react";
import { Field, reduxForm } from "redux-form";
import validate from "./validate";
import renderField from "./renderField";
import Typography from "@material-ui/core/Typography";
import NormalizeZip from "./normalizeZip"
import normalizePhone from "./normalizePhone"





const requiredLength = len => value =>
  value && value.length !== len
    ? `Must be ${len - 2} characters long`
    : undefined;
const requiredLength12 = requiredLength(12);



const WizardFormSecondPage = props => {
  const { handleSubmit, previousPage, pristine, submitting } = props;
  return (
    <Fragment>
      <Typography variant="title" color="inherit">
        Personal Information
      </Typography>
      <hr />
      <form onSubmit={handleSubmit}>

       <Field
          name="cwdCode"
          type="text"
          component={renderField}
          label="CWD Code"
        />
        <Field
          name="customerID"
          type="text"
          component={renderField}
          label="Customer ID"
        />
         <Field
          name="gameCheckNumber"
          type="text"
          component={renderField}
          label="Game Check Number"
        />

        <Field
          name="firstName"
          type="text"
          component={renderField}
          label="First Name"
        />
        <Field
          name="lastName"
          type="text"
          component={renderField}
          label="Last Name"
        />
         <Field
          name="address"
          type="text"
          component={renderField}
          label="Street Address"
        />
        <Field
          name="city"
          type="text"
          component={renderField}
          label="City"
        />
        <Field
          name="zipCode"
          type="text"
          component={renderField}
          normalize={NormalizeZip}
          label="Zip Code"
        />

         <Field
          name="phoneNumber"
          type="text"
          component={renderField}
          normalize={normalizePhone}
          label="Phone Number"
          validate={requiredLength12}
        />
       
       

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={previousPage}
          >
            Previous
          </button>

         

          <button
            className="btn btn-success"
            type="submit"
            disabled={pristine || submitting}
          >
            Next
          </button>
        </div>
      </form>
    </Fragment>
  );
};

export default reduxForm({
  form: "wizard", //Form name is same
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  validate
})(WizardFormSecondPage);



// WEBPACK FOOTER //
// ./src/components/wizardSection/WizardFormSecondPage.jsx